import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { InsuranceCompany } from "../../insurance-companies/_types/insurance-company";
import { Trade } from "../../common/_types/trade";

export class ClientPolicy extends Resource {
    public override type = 'clientPolicies';

    @prop()
    public clientId!: string;

    @prop()
    public insuranceCompanyId!: string;

    public insuranceCompany!: InsuranceCompany;

    @prop()
    @required()
    public policyNumber!: string;

    @prop()
    @required()
    public description!: string;

    @prop()
    public displayName!: string;

    @prop()
    public franchisePrice?: string;

    
    @prop()
    public tradeId!: string;

    public trade!: Trade;
}